import { render } from "./email-sidebar.vue?vue&type=template&id=6de8909f"
import script from "./email-sidebar.vue?vue&type=script&lang=js"
export * from "./email-sidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__